import { render, staticRenderFns } from "./InformacionAmpliadaComponent.vue?vue&type=template&id=880a7952&"
import script from "./InformacionAmpliadaComponent.vue?vue&type=script&lang=js&"
export * from "./InformacionAmpliadaComponent.vue?vue&type=script&lang=js&"
import style0 from "./InformacionAmpliadaComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports